import {
  calculateFilterKey,
  normalizeHeader,
  normalizeQueue,
  parseFilledMetric,
  parseLiteralDateTime,
  queueContributesToTimeMetrics,
} from '../domain/businessRules'

export interface ImportSourceRow {
  startedAt: unknown
  operator: unknown
  queue: unknown
  conversationSeconds: unknown
  waitingSeconds: unknown
}

export interface PublicationMetric {
  operator_external_name: string | null
  operator_display_name: string | null
  queue_code: string
  queue_display_name: string
  attendance_count: number
  tma_total_seconds: number
  tma_sample_count: number
  tme_total_seconds: number
  tme_sample_count: number
}

function queueCode(queue: string): string {
  if (queue === 'Default') return 'DEFAULT'
  return normalizeHeader(queue).toUpperCase().replace(/\s+/g, '_') || 'SEM_FILA'
}

export function buildPublicationMetrics(rows: ImportSourceRow[]): PublicationMetric[] {
  const grouped = new Map<string, PublicationMetric>()

  for (const row of rows) {
    const dateTime = parseLiteralDateTime(row.startedAt)
    if (calculateFilterKey(dateTime) !== 'OK') continue

    const operator = String(row.operator ?? '').trim() || null

    const queue = normalizeQueue(row.queue)
    const code = queueCode(queue)
    const key = `${operator?.toLocaleLowerCase('pt-BR') ?? '__unassigned__'}\u0000${code}`
    const metric = grouped.get(key) ?? {
      operator_external_name: operator,
      operator_display_name: operator,
      queue_code: code,
      queue_display_name: queue === 'Default' ? 'Navegação automática' : queue,
      attendance_count: 0,
      tma_total_seconds: 0,
      tma_sample_count: 0,
      tme_total_seconds: 0,
      tme_sample_count: 0,
    }

    metric.attendance_count += 1

    if (queueContributesToTimeMetrics(queue)) {
      const tma = parseFilledMetric(row.conversationSeconds)
      if (tma !== null && tma >= 0) {
        metric.tma_total_seconds += tma
        metric.tma_sample_count += 1
      }

      const tme = parseFilledMetric(row.waitingSeconds)
      if (tme !== null && tme >= 0) {
        metric.tme_total_seconds += tme
        metric.tme_sample_count += 1
      }
    }

    grouped.set(key, metric)
  }

  return [...grouped.values()].sort((a, b) =>
    (a.operator_external_name ?? '').localeCompare(b.operator_external_name ?? '', 'pt-BR')
      || a.queue_display_name.localeCompare(b.queue_display_name, 'pt-BR'),
  )
}
